// When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const systemRoutes = {
  component: Layout,
  redirect: 'noredirect',
  name: 'System',
  alwaysShow: true,
  meta: {
    title: '系统管理',
    permissions: 'system',
    icon: 'ali-system',
  },
  children: [
    // 用户管理

    // 用户列表
    {
      // 路由地址
      // 文件路径
      component: () => import('@/views/system/user-manage/index'),
      // 路由名称
      name: 'UserList',
      // 左边导航
      meta: { title: '用户管理', permissions: 'system-user', icon: 'ali-user' },
    },

    // 媒体用户管理
    {
      component: () => import('@/views/system/media-user-manage/index'),
      name: 'MediaUserList',
      meta: {
        title: '媒体用户管理',
        permissions: 'system-media',
        icon: 'ali-media',
      },
    },

    // 授权管理
    {
      component: () => import('@/views/system/auth-manage/index'),
      name: 'AuthManage',
      meta: {
        title: '授权管理',
        permissions: 'auth-manage',
        icon: 'ali-media',
      },
    },

    // 广告配置
    {
      component: () => import('@/views/system/advertiser-config/index'),
      name: 'AdvertiserConfig',
      meta: { title: '广告配置', permissions: 'advertiser-config', icon: 'ali-system' },
    },

    // 应用管理
    {
      component: () => import('@/views/system/app-manage/index'),
      name: 'AppList',
      meta: { title: '应用管理', permissions: 'system-app', icon: 'ali-app' },
    },

    // 操作日志
    {
      component: () => import('@/views/auxiliary/log/index'),
      name: 'LogList',
      meta: {
        title: '操作日志',
        permissions: 'system-log',
        icon: 'ali-operation-log',
      },
    },

    // 角色管理
    {
      component: () => import('@/views/system/role-manage/index'),
      name: 'RoleManage',
      meta: {
        title: '角色管理',
        permissions: 'role-manage',
        icon: 'admin',
      },
    },

    // 菜单管理
    {
      component: () => import('@/views/system/menu-manage/index'),
      name: 'MenuManage',
      meta: {
        title: '菜单管理',
        permissions: 'menu-manage',
        icon: 'admin',
      },
    },

    // 权限管理
    {
      component: () => import('@/views/system/permission-manage/index'),
      name: 'PermissionManage',
      meta: {
        title: '权限管理',
        permissions: 'permission-manage',
        icon: 'admin',
      },
    },

    // 枚举值管理
    {
      component: () => import('@/views/system/enum-manage/index'),
      name: 'EnumManage',
      meta: {
        title: '枚举值管理',
        permissions: 'system-enumManage',
        icon: 'ali-alert',
      },
    },

    // 投放设置
    {
      component: () => import('@/views/system/put-in-setting/index'),
      name: 'PutInSetting',
      meta: {
        title: '投放设置',
        permissions: 'put-in-setting',
        icon: 'admin',
      },
      children: [
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingJrtt',
          meta: { title: '今日头条', permissions: 'put-in-setting-jrtt', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingGdt',
          meta: { title: '广点通', permissions: 'put-in-setting-gdt', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingBaidu',
          meta: { title: '百度', permissions: 'put-in-setting-baidu', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingBilibili',
          meta: { title: 'B站', permissions: 'put-in-setting-bilibili', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingKuaishou',
          meta: { title: '快手', permissions: 'put-in-setting-kuaishou', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingHuaWei',
          meta: { title: '华为', permissions: 'put-in-setting-huawei', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingOppo',
          meta: { title: 'OPPO', permissions: 'put-in-setting-oppo', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingVivo',
          meta: { title: 'VIVO', permissions: 'put-in-setting-vivo', icon: 'admin' },
        },
        {
          component: () => import('@/views/system/put-in-setting'),
          name: 'PutInSettingXiaoMi',
          meta: { title: '小米', permissions: 'put-in-setting-xiaomi', icon: 'admin' },
        },
      ],
    },
  ],
};

export default systemRoutes;
